<template>
  <div class="row py-0 align-items-center">
    <div v-if='item.TypeRole === 3 || item.TypeRole === 0' class="col-7  pr-3 pl-1">
      <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}">
        <v-avatar>
          <img
              :src="$replaceHttps(item.VendorPictureLogoUrl)"
              alt="لوگو برند">
        </v-avatar>
      </router-link>
      <span class="pr-2">{{ item.VendorName }}</span>
    </div>
    <div v-else class="col-7  pr-7">
      <router-link :to="{path:'ProfileInSite',query:{ID:item.AppUser.Id}}">
        <v-avatar>
          <img
              :src="$replaceHttps(item.AppUser.FileUrl)"
              alt="تصویر کاربر">
        </v-avatar>
      </router-link>
      <span class="pr-2">{{ item.AppUser.Name + ' ' + item.AppUser.Family }}</span>
    </div>
    <div v-if="item.LocationTitle !== null" class="col-5 text-left pl-7 pb-4 pr-1 d-inline-block"
         @click="openMap(item.Latitude,item.Longitude)">
      <span class="pl-2 text-nowrap font11px pointer">{{ item.LocationTitle }}</span>
      <i class="fa-solid fa-location-dot font19px transform-icon primary-text pointer"></i>
    </div>
    <div class="col-12 px-0 px-sm-4 position-relative pt-1">
      <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="false"
          class="carousel-dots"
          dark
          delimiter-icon="fa-solid fa-circle-small white--text"
          height="500"
          hide-delimiter-background>
        <v-carousel-item
            v-for="(slide, i) in item.files"
            :key="i" style="height:500px">

          <VideoPlayer v-if="slide.type ===2" :videoSrc="slide.src"/>
          <v-img v-else :src="$replaceHttps(slide.src)" class="col-12 bg-black" contain height="500">
          </v-img>
        </v-carousel-item>
        <div class="d-flex align-items-end flex-column justify-content-end position-absolute posts-icons-wrapper">
          <div class=" py-2 px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark"
                  @click="likeMedia(item.VendorSocialNetworkID,item)">
            <i
                :class="likeActive ?'fas fa-heart red--text' :'fas fa-heart'"
                class="font16px white--text "
            ></i>
              </span>
          </div>
          <div class="  px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark" @click="openSendComments(item.VendorSocialNetworkID)">
            <i :class="commentsActive ?'red--text' :''"
               class="font16px white--text fa-solid fa-comments"></i>
                </span>
          </div>
          <div class=" py-2 px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark"
                  @click="copy('https://eyvankhaneh.app/TrendDetail?VendorSocialNetworkID='+item.VendorSocialNetworkID)">
            <i class="font16px white--text fa-solid fa-paper-plane"></i>
              </span>
          </div>
          <div v-if="isSaveStatuLoaded" class=" px-1 pb-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark"
                  @click="setBookMark(item.VendorSocialNetworkID,bookMarkActive)">
            <i :class="bookMarkActive ?'fas fa-bookmark red--text' :'fas fa-bookmark'"
               class="font16px white--text"></i>
              </span>
          </div>
          <div v-if="item.SelectedProducts !== null" class=" py-2 px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark" @click="openRelatedProducts">
            <i :class="relatedProductsActive ? 'red--text':''"
               class="font16px white--text fa-solid fa-paperclip"></i>
              </span>

          </div>
        </div>
      </v-carousel>
    </div>
    <div class="col-7 pt-0 ">
      <v-btn class="pl-1" icon @click="openReportSheet = !openReportSheet"><i
          class="fa-regular fa-ellipsis-vertical font24px  primary-text"></i></v-btn>
      <router-link v-if='item.TypeRole === 3 || item.TypeRole === 0'
                   :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}"
                   class="text-decoration-underline text-truncate">{{ item.VendorName }}
      </router-link>
      <span v-else class="text-decoration-underline text-truncate">{{
          item.AppUser.Name + ' ' + item.AppUser.Family
        }}</span>
    </div>
    <div class="col-5 pt-0 text-left">
      <span>{{ item.CountLike }}</span>
      <span class="ml-2 mr-7">like</span>
      <span>{{ item.CountVisit }}</span>
      <span class="ml-2">view</span>
    </div>
    <div class="col-12 font12px" v-html="item.Description">
    </div>
    <div class="col-12  ">
      <router-link v-for="(tag,i) in item.hashtags" :key="i" :to="{path:'Trends',query:{ID:tag.HashTagID}}"
                   class="font12px grey--text"> #{{ tag.Content }}
      </router-link>
    </div>
    <div class="col-6">
      <v-btn text @click="getPostDetail(item.VendorSocialNetworkID)"> نمایش نظرات<i
          class="fa-solid fa-arrow-left transform-icon pr-1"></i></v-btn>
    </div>
    <div class="col-6 text-left">
      <span class="font12px">{{ $convertDate(item.ModifiedDate) }}</span>
      <i class="fa-solid fa-clock-eight font16px transform-icon mr-2"></i>
    </div>
    <v-bottom-sheet v-model="openCommentSheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            نمایش نظرات
          </div>
          <div class="col-auto pr-0 pl-0">
            <i class="fa-solid fa-arrow-down fa-xl"></i>
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openCommentSheet = !openCommentSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div v-if="comments.length <= 0" class="col-12  text-center">
          <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
          <div class="mt-2">
            هنوز نظری ثبت نشده است
          </div>

        </div>
        <div v-for="item in comments" v-else :key="item.VoteID" class="row mx-1">
          <div class="col-9 forth-bg rounded-lg pl-1"  @click="goToCommentOwnerProfile(item)">
            <v-avatar size="38">
              <img :src="$replaceHttps(item.AppUserUrl)" alt="تصویر کاربر">
            </v-avatar>
            <span class="font-weight-bold mr-1" dir="ltr">: {{ item.AppUserName }} </span>
            <span class="font-weight-normal">{{ item.Description }}</span>
          </div>
          <div class="col-3 text-left">
            <div> {{ $convertDate(item.ModifiedDate) }}</div>
            <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
          </div>
          <div class="col-12">
            <div v-if="item.AnswerDescription !== null" class="row">
              <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
              <div class="col-8 forth-bg rounded-lg pb-0" @click="goToCommentReplyProfile(item)">
                <v-avatar size="38">
                  <img :src="$replaceHttps(item.VendroPictureUrl)" alt="تصویر پاسخ دهنده">
                </v-avatar>
                <span class="font-weight-bold mr-1">{{ item.VendorName }} :</span>
                <span class="font-weight-normal">{{ item.AnswerDescription }}</span>
              </div>
              <div class="col-3 text-left pb-0 reply-comments-action">
                <div>{{ $convertDate(item.AnswerDate) }}</div>
                <div>{{ item.CountLike }}
                  <v-btn icon small @click="like(item.VoteID)"><i class="fa-solid fa-thumbs-up fa-xl  green--text"></i>
                  </v-btn>
                </div>
                <div>{{ item.CountDislike }}
                  <v-btn icon small><i class="fa-solid fa-thumbs-down fa-xl  red--text"
                                       @click="dislike(item.VoteID)"></i></v-btn>
                </div>
              </div>
            </div>
          </div>

        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openSendCommentSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            نظر خود را بنویسید
          </div>

          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="closeCommentsSheet">

           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 ">
            <v-textarea
                v-model="commentDescription"
                auto-grow
                background-color="secondary"
                flat
                full-width
                hide-details
                placeholder="این محتوا ..."
                rows="4"
                solo>
            </v-textarea>
          </div>
          <div class="col-3 pl-0">
            امتیاز دهید
          </div>
          <div class="col-7 pr-0">
            <v-rating
                v-model="rate"
                background-color="black"
                color="yellow"
                dense
                length="10"
                size="22"
            ></v-rating>
          </div>
          <div class="col-12 text-left pt-0">
            <v-btn class="pl-1 pb-1" icon @click="registerComment">
              <i class="fa-solid fa-square-check fa-3x black--text"></i>
            </v-btn>
          </div>

        </div>


      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openReportSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8">
            مشکل در کدام بخش است؟
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openReportSheet = !openReportSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 pt-0">
            <v-radio-group v-model="radioGroup" hide-details>
              <v-radio
                  label="کلاهبرداری و نقض قانون یا وقوع جرم"
                  value="کلاهبرداری و نقض قانون یا وقوع جرم"
              ></v-radio>
              <v-radio
                  label="محتوای آگهی"
                  value="محتوای آگهی"
              ></v-radio>
              <v-radio
                  label="مشکلات صاحب آگهی"
                  value="مشکلات صاحب آگهی"
              ></v-radio>
              <div class="row">
                <div class="col-2">
                  <v-radio
                      label="سایر"
                      @change="otherReport = true"
                      :value="reportDescription"
                  ></v-radio>
                </div>
                <div  class="col-8 pl-0">
                  <v-textarea
                      auto-grow
                      :disabled="!otherReport"
                      v-model="reportDescription"
                      background-color="secondary"
                      flat
                      full-width
                      hide-details
                      placeholder="این محتوا ..."
                      rows="4"
                      solo>
                  </v-textarea>
                </div>
                <div class="col-2 align-self-end ">
                  <v-btn class="pl-1 pb-1" icon @click="reportPost">
                    <i class="fa-solid fa-square-check fa-3x black--text"></i>
                  </v-btn>
                </div>
              </div>


            </v-radio-group>
          </div>

        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openRelatedProductsSheet" persistent>
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto pr-6 pl-0">
            <i class="fa-solid fa-paperclip fa-2x"></i>
          </div>
          <div class="col-auto font-weight-bold">
            محصولات مرتبط با این محتوا
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="closeProductsSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="col-12">
          <div v-if="isRelatedProductsLoaded" class="row">
            <div class="col-11 pl-0" dir="ltr">
              <carousel
                  v-if="item.relatedProducts.length >0"
                  :autoplay="false"
                  :autoplayTimeout="7000"
                  :dots="false"
                  :margin="8"
                  :nav="true"
                  :navText="navText"
                  :responsive="{0:{items:2},600:{items:3},960:{items:4}
                                                ,1050:{items:5}}"
                  :rtl="true"
                  class="owl-carousel-post-card">
                <div v-for="(product,i) in item.relatedProducts" :key="i">
                  <ProductCard :item="product"/>
                </div>
              </carousel>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"
    >
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ProductCard from "@/components/ProductCard";
import VideoPlayer from "@/components/VideoPlayer";


export default {
  props: ['item'],
  name: "PostCard",
  components: {
    VideoPlayer,
    ProductCard,
    carousel,
  },
  data: () => ({
    radioGroup: null,
    reportDescription:'',
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
    showLoaderDialog: false,
    showResult: false,
    text: '',
    cycle: false,
    openSendCommentSheet: false,
    openCommentSheet: false,
    openRelatedProductsSheet: false,
    openReportSheet: false,
    isRelatedProductsLoaded: true,
    relatedProductsActive: false,
    likeActive: false,
    bookMarkActive: false,
    commentsActive: false,
    relatedProducts: [],
    comments: [],
    canCopy: false,
    resultText: '',
    vendorSocialNetworkID: null,
    commentDescription: null,
    otherReport:false,
    rate: 0,
    vendorSocialID:null,
    isSaveStatuLoaded:false,
  }),
  mounted() {
    this.checkUserSaveOrLikePost()
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  methods: {
    async copy(s) {
      await navigator.clipboard.writeText(s);
      this.resultText = 'لینک کپی شد.'
      this.showResult = true
    },
    checkUserSaveOrLikePost() {
      let saves = this.$store.getters.getUserPostsBookMark
      console.log('save',saves)
      let likes = this.$store.getters.getUserPostsLikes

      let id = this.item.VendorSocialNetworkID
      if (saves !== null && saves.length > 0) {
        if (saves.find(x => x.VendorSocialNetworkID === id) !== undefined) {
          console.log('1')
          this.bookMarkActive = true
        }
      }
      if (likes !== null && likes.length > 0) {
        if (likes.find(x => x.VendorSocialNetworkID === id) !== undefined) {
          this.likeActive = true
        }
      }
      this.isSaveStatuLoaded=true
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    openRelatedProducts() {
      this.relatedProductsActive = !this.relatedProductsActive
      this.openRelatedProductsSheet = !this.openRelatedProductsSheet
    },
    closeProductsSheet() {
      this.relatedProductsActive = !this.relatedProductsActive
      this.openRelatedProductsSheet = !this.openRelatedProductsSheet
    },
    openSendComments(id) {
      this.vendorSocialNetworkID = id
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    closeCommentsSheet() {
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    getPostDetail(id) {
      this.vendorSocialID = id
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SpecialSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)

            this.comments = json.VoteViewModel
            this.openCommentSheet = true

          })
          .catch(error => console.log('error', error));
    },
    like(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getPostDetail(this.vendorSocialID)
          })
          .catch(error => console.log('error', error));
    },
    dislike(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteDislike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getPostDetail(this.vendorSocialID)
          })
          .catch(error => console.log('error', error));
    },
    registerComment() {
      this.openSendCommentSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.vendorSocialNetworkID);
      urlencoded.append("Rate", this.rate);
      urlencoded.append("Description", this.commentDescription);
      urlencoded.append("TypeVote", "2");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVote", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.commentsActive = !this.commentsActive
          })
          .catch(error => console.log('error', error));
    },
    likeMedia(id, item) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetSocialNetworkLike", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.likeActive = !this.likeActive
              if (this.likeActive) {
                item.CountLike++
              } else {
                item.CountLike--
              }

            }
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    setBookMark(id, isBookMark) {
      if (isBookMark) {
        this.removeBookmark(id)
      } else {
        this.addBookmark(id)
      }
    },
    addBookmark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", id);
      urlencoded.append("TypeBookMark", "3");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false

            if (resStatus === 200) {
              this.bookMarkActive = true

              this.$store.commit('addOrRemovePostBookMarkItemToList', id)
            }
            this.resultText = result
            this.showResult = true


          })
          .catch(error => console.log('error', error));
    },
    removeBookmark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("BookMarkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/RemoveBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false

            if (resStatus === 200) {
              this.bookMarkActive = false

              this.$store.commit('addOrRemovePostBookMarkItemToList', id)
            }
            this.resultText = result
            this.showResult = true


          })
          .catch(error => console.log('error', error));
    },
    openMap(lat, lng) {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = "https://www.google.com.sa/maps/search/" + lat + ',' + lng + "?hl=en"
      a.target = '_blank'
      // a.download = <your_fileName>;
      a.click();
      document.body.removeChild(a);
    },
    reportPost(){
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", this.item.VendorSocialNetworkID);
      urlencoded.append("Description", this.radioGroup);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVendorSocialNetworkReportFailure", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            this.openReportSheet=false
            this.resultText=result
            this.showResult=true
          })
          .catch(error => console.log('error', error));
    },
    goToCommentOwnerProfile(item){
      if(item.TypeRoleCommentOwner === "Vendor"){
        this.$router.push({path:'StoreProfile',query:{VendorID:item.VendorCommentOwnerId}})
      }else {
        this.$router.push({path:'ProfileInSite',query:{ID:item.AppUserId}})
      }
    },
    goToCommentReplyProfile(item){
      if(item.TypeRole === "Vendor"){
        this.$router.push({path:'StoreProfile',query:{VendorID:item.VendorID}})
      }else {
        this.$router.push({path:'ProfileInSite',query:{ID:item.VendorID}})
      }
    }
  }
}
</script>

